interface MonthYearDropdownProps {
    month: Date;
    onChange: (date: Date) => void;
}

export function MonthYearDropdown({
    month,
    onChange,
}: MonthYearDropdownProps): JSX.Element {
    const years: number[] = Array.from(
        { length: 10 },
        (_, i) => 2020 + i
    );

    const months: number[] = Array.from(
        { length: 12 },
        (_, i) => i
    );

    return (
        <div className="flex items-center gap-2">
            {/* 월 */}
            <select
                value={month.getMonth()}
                onChange={(e) =>
                    onChange(
                        new Date(
                            month.getFullYear(),
                            Number(e.target.value)
                        )
                    )
                }
                className="rounded-md border px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
                {months.map((m) => (
                    <option key={m} value={m}>
                        {m + 1}월
                    </option>
                ))}
            </select>

            {/* 년 */}
            <select
                value={month.getFullYear()}
                onChange={(e) =>
                    onChange(
                        new Date(
                            Number(e.target.value),
                            month.getMonth()
                        )
                    )
                }
                className="rounded-md border px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
                {years.map((y) => (
                    <option key={y} value={y}>
                        {y}년
                    </option>
                ))}
            </select>
        </div>
    );
}
